import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import {
  useAdvertContactsState,
  UseAdvertContactsVisibleControlResultType,
  useAdvertContactsLoadContext,
} from '#advertContacts/hooks';
import {
  hide,
  open,
  setIsLoadInProcess,
  setIsLoaded,
} from '#advertContacts/reducers';

const useAdvertContactsVisibleControl = (): UseAdvertContactsVisibleControlResultType => {
  const { isOpen, isLoaded } = useAdvertContactsState();
  const { AdvertContacts } = useAdvertContactsLoadContext();
  const dispatch = useDispatch();

  const triggerOpen = useCallback(() => {
    if (isLoaded) {
      dispatch(open());
      return;
    }

    dispatch(setIsLoadInProcess(true));
    AdvertContacts.load().then(() => {
      dispatch(setIsLoadInProcess(false));
      dispatch(setIsLoaded(true));
      dispatch(open());
    });
  }, [AdvertContacts, dispatch, isLoaded]);

  const triggerHide = useCallback(() => {
    dispatch(hide());
  }, [dispatch]);

  return {
    isOpen,
    open: triggerOpen,
    hide: triggerHide,
  };
};

export { useAdvertContactsVisibleControl };
